import { render } from "./NotificationsTable.vue?vue&type=template&id=54c765f4&scoped=true"
import script from "./NotificationsTable.vue?vue&type=script&lang=js"
export * from "./NotificationsTable.vue?vue&type=script&lang=js"

import "./NotificationsTable.vue?vue&type=style&index=0&id=54c765f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c765f4"],['__file',"src/containers/event/eventSettings/components/NotificationsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54c765f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54c765f4', __exports__)) {
    api.reload('54c765f4', __exports__)
  }
  
  module.hot.accept("./NotificationsTable.vue?vue&type=template&id=54c765f4&scoped=true", () => {
    api.rerender('54c765f4', render)
  })

}


export default __exports__